/*
 * Autoplay for product-card videos rendered by snippets/card-product-pdp.liquid
 * (.pdp-rec-card__media video). Plays a card video while at least half of it is
 * visible and pauses it off-screen. A MutationObserver re-attaches to videos in
 * markup injected after page load (facet filtering, infinite scroll, AJAX-loaded
 * recommendations), which a DOMContentLoaded-only script would miss.
 */
(() => {
  if (window.pdpRecCardVideosInitialized) return;
  window.pdpRecCardVideosInitialized = true;

  const SELECTOR = '.pdp-rec-card__media video';

  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Markup injected via innerHTML can carry the muted attribute without the
          // muted property being set, which makes browsers block autoplay.
          entry.target.muted = true;
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  // Re-observing an already observed element is a no-op, so attach() may overlap.
  const attach = (root) => {
    if (root.matches && root.matches(SELECTOR)) visibilityObserver.observe(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach((video) => visibilityObserver.observe(video));
  };

  const start = () => {
    attach(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => attach(node)));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
